import { GruppoTerritoriale } from '../gruppo-territoriale';
import { Utente } from '../utente';

export class AssegnazioneGruppiTerritorialiRequest {
  gruppi: GruppoTerritoriale[];
  utente: Utente;
  cambioUfficio: boolean = false;
}
